"use strict";
/**
 * FP-037's strings (Paul, 2026-10-05), ONE copy for both clients (shared-copy-keys
 * rule, HANDOVER §2 rule 17). Agreed with mobile in writing.
 *
 * The state: the user owns their split and has no active debt. The Debt Payoff Fund
 * keeps its stored share but funds nothing (`unfunded_reason: "no_debts"` on the
 * Forecast allocation), and the dashboard's "Debt payment completed" bar has nothing
 * to plan (`debt.reason: "no_debts"` on the remainder payload). Both say the same
 * thing. Distinct from X-01's "no debt payment due this period", which means debts
 * exist but nothing is due in the window.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSIGNED_ALL_WITH_KEPT = exports.ADD_A_DEBT_LINK = exports.UNFUNDED_NO_DEBTS = exports.ADD_DEBT_TO_FUND = exports.NO_DEBTS_TRACKED = void 0;
exports.keptForDebts = keptForDebts;
/** Forecast bucket amount line and the dashboard debt bar's value. */
exports.NO_DEBTS_TRACKED = "no debts tracked";
/** Caption under the disabled slider; links to the Debt Eliminator. */
exports.ADD_DEBT_TO_FUND = "Add a debt to fund this bucket";
/** The reason value both payloads carry. */
exports.UNFUNDED_NO_DEBTS = "no_debts";
/**
 * Forecast, under the allocation banner, while a bucket is unfunded: its share is
 * LOCKED (counted toward 100%, untouched by any drag), so the user is told where
 * it sits rather than warned that it is "left to allocate". `pct` and `amount` are
 * the client's own formatted figures. Followed by `ADD_A_DEBT_LINK`.
 *
 * Reworded before release (Paul's check, 2026-10-05). This said "15% ($241.97) is
 * set aside for debts.", which is false: the unfunded row is built with
 * `effective_amount` 0, its share still counts in `percent_total` so no fixed-dollar
 * bucket takes it, and the percent buckets get only their own share. The SHARE is
 * kept; the DOLLARS are in no bucket at all. The name changed with the words, so it
 * stops making the old claim. Agreed with mobile in writing; Paul approves the final
 * sentence with the other FP-037 strings.
 */
function keptForDebts(pct, amount) {
    return `${pct}% is kept for debts. Its ${amount} isn’t in any bucket until you add a debt.`;
}
/** The link after `keptForDebts`; web → /debt, mobile → Debt Eliminator. */
exports.ADD_A_DEBT_LINK = "Add a debt";
/**
 * The Forecast allocation banner's message at 100% while a share is unfunded. It
 * replaces "You've allocated 100% of each paycheck's remainder! Great job!", which
 * claimed too much: the kept share's dollars are in no bucket. While a share is
 * unfunded the banner's headline also shows the percentage alone, no dollars (Paul,
 * 2026-10-05: "The banner is about the percentage; let it say the percentage."), and
 * `keptForDebts` underneath says which share and how much. Under and over keep their
 * dollars: that gap is real money. Agreed with mobile in writing; ships in #1667.
 */
exports.ASSIGNED_ALL_WITH_KEPT = "Every share is assigned. One is waiting for a debt.";
//# sourceMappingURL=debtBucketCopy.js.map